import React, { useState, useEffect, useMemo } from "react";
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "react-redux";
import { setSearchTerm } from "../../redux/slice/panelsSlice";
import { useNavigate } from "react-router-dom";
import { fetchDropdownList } from "../../redux/slice/getDropdownListSlice";

const MasterPanel = ({ panelName, onItemSelect, activeItemHeading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const panelState = useSelector((state) => state.panels[panelName]);
    const objectData = useSelector(state => state.dropdownList.dropdownList);

    const supportItems = useMemo(() => [
        { heading: 'SUPPORT CONFIG' },
        { heading: 'ASSIGNMENT FOR CATEGORY' }
    ], []);

    const transformedItems = useMemo(() => {
        if (panelName === 'Support') {
            return supportItems;
        }
        if (panelName !== 'Pre Onboarding') return [];
        if (!objectData || typeof objectData !== 'object' || Array.isArray(objectData)) return [];

        return Object.keys(objectData).map(key => ({
            heading: key,
        }));
    }, [objectData, panelName]);
    const searchTerm = panelState ? panelState.searchTerm : '';
    const filteredItems = useMemo(() => {
        if (!searchTerm) {
            return transformedItems;
        }
        if (!(panelName === 'Pre Onboarding' || panelName === 'Support')) return [];
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return transformedItems.filter(item =>
            item.heading.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }, [transformedItems, searchTerm, panelName]);


    useEffect(() => {
        if (panelName === 'Pre Onboarding') {
            dispatch(fetchDropdownList());
        }
    }, [dispatch]);

    if (!panelState) {
        return null;
    }

    const handleSearchChange = (e) => {
        dispatch(
            setSearchTerm({
                panelName: panelName,
                term: e.target.value,
            })
        );
    };

    const handleToggle = () => {
        console.log("btn clicked");
        setIsOpen(!isOpen);
    };
    const handleItemClick = (item) => {
        const itemWithData = {
            heading: item.heading,
            data: panelName === 'Pre Onboarding' ? objectData?.[item.heading] : null
        }
        onItemSelect(itemWithData);
    };

    const chevronClass = isOpen ? "rotate-up" : "rotate-down";
    const headerClasses = `card-header-setting bg-white d-flex justify-content-between align-items-center fw-bold clickable-header ${isOpen ? "" : "closed-header-centered "
        }`;

    return (
        <div className="card shadow-sm border-left-0 border-right-0 mb-0 rounded-0 border-bottom-1 border-top-0">
            <div className={headerClasses}>
                <button type="button" className="settings-btn" aria-expanded={isOpen}
                    aria-controls={`panel-content-${panelName.replace(/\s+/g, '-')}`} onClick={handleToggle}>
                    <span>{panelName}</span>
                    <i className={`bi bi-chevron-up ${chevronClass}`} aria-hidden="true" style={{ cursor: "pointer", transition: "transform 0.2s" }}></i>
                </button>
            </div>

            <div id={`panel-content-${panelName.replace(/\s+/g, '-')}`} className={`collapse ${isOpen ? "show" : ""}`}>
                <div className="p-3 border-bottom">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={searchTerm}
                        aria-label={`Search items in ${panelName}`}
                        onChange={handleSearchChange}
                    />
                </div>

                <div className="list-container">
                    <ul className="list-group list-group-flush">
                        {filteredItems.map((item) => {
                            const isActive = activeItemHeading === item.heading;
                            return (
                                <li
                                    key={item.heading}
                                    className={`list-group-item list-group-item-action py-3 px-3 ${isActive ? 'activeItem' : ''} `}
                                >
                                    <button
                                        type="button"
                                        className={`settings-btn list-group-item-action w-100 text-start border-0 ${isActive ? 'activeCta' : ''}`}
                                        onClick={() => handleItemClick(item)}
                                    >
                                        <h6 className="mb-1 fw-bold">{item.heading?.replace(/_/g, " ")}</h6>
                                    </button>
                                </li>
                            )
                        })}
                        {filteredItems.length === 0 && (
                            <li className="list-group-item text-center text-muted">
                                No results found
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

MasterPanel.propTypes = {
    panelName: PropTypes.string.isRequired
};

export default MasterPanel;